module.exports = "<!--Page Container-->\n<section class=\"main-container\">\n\n  <page-header></page-header>\n\n  <div class=\"container-fluid page-content\">\n\n    <app-navios-viagens-table [id_navio]=\"id_navio\" *ngIf=\"!pageIsUpd && !pageIsAdd\"></app-navios-viagens-table>\n\n  </div>\n\n  <page-footer></page-footer>\n\n</section>\n<!--/Page Container-->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/navios-viagens/navios-viagens.component.html
// module id = ./src/app/navios-viagens/navios-viagens.component.html
// module chunks = main